import React from "react";
import "./order-details.scss";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Paper from "@material-ui/core/Paper";
import { withRouter } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
    table: {},
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
}));

const OrderDetails = ({ order }) => {
    const classes = useStyles();

    const createRows = (label, value) => ({ label, value });
    let rows = [];
    if (order && order.consignments) {
        let amount = 0;
        Object.keys(order.consignments).map(key=>{
            amount += order.consignments[key].quantityMeasured * order.consignments[key].pricePerKg;
        });

        rows.push(createRows("Order Id:", order.id));
        rows.push(createRows("No. of Shipments:", order.consignmentCount));
        rows.push(createRows("Total amount:", amount.toFixed(2)));
        rows.push(
            createRows(
                "Shipment date",
                order.expectedShipmentDate
                    ? order.expectedShipmentDate.toDate().toLocaleDateString()
                    : ""
            )
        );
        rows.push(
            createRows(
                "Order date",
                order.orderedOn.toDate().toLocaleDateString()
            )
        );
        rows.push(
            createRows(
                "Address",
                order.warehouse
                    ? `${order.warehouse.name}, ${order.warehouse.streetAddress}, ${order.warehouse.landmark}, ${order.warehouse.city}, ${order.warehouse.state} - ${order.warehouse.pincode}`
                    : ""
            )
        );
        rows.push(createRows("Status:", order.status));
    }

    const viewInvoice = (id) => {
        openInTab("https://us-central1-ofish-53c9f.cloudfunctions.net/GetRetailInvoice" + "?invoiceId=" + id)
    }

    const openInTab = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        link.parentElement.removeChild(link);
    }

    return !order ? (
        ""
    ) : (
        <Container style={{ maxWidth: 850 }}>
            <Paper className={classes.paper}>
                <Typography variant={"h6"}>Order details</Typography>
                <TableContainer>
                    <Table
                        className={classes.table}
                        size="small"
                        aria-label="a dense table"
                    >
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.label}>
                                    <TableCell component="th" scope="row">
                                        {row.label}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.value}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            {
                order.status === "CLOSED" ||
                order.status === "PAID"?
                    <div style={{
                        marginTop: 10,
                        textAlign: 'right'
                    }} >
                        <Button color={'primary'} variant={'contained'} onClick={()=>{
                            viewInvoice(order.id)
                        }}>Download invoice</Button>

                    </div>: ""
            }
        </Container>
    );
};
const mapStateToProps = ({ common }) => ({
    order: common.current,
});
export default withRouter(connect(mapStateToProps)(OrderDetails));
